import { DateTime } from 'luxon';
import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { calculateNextDate } from '../recurring-transaction-utils';
import { logAndThrowError } from '../../utils/errors';
import { useGetUserApi } from '../../user/api/use-get-user';
export const useUpdateRecurringTransactionApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const { data: user } = useGetUserApi({});
    const queryKey = ['recurring-transactions', budgetId];
    // api call
    const updateRecurringTransactionApi = async (data) => {
        await api.put('/recurring-transaction', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No recurring transactions data found');
        }
        const updatedTransactions = [...oldData];
        const transactionIndex = updatedTransactions.findIndex((t) => t.id === request.id);
        if (transactionIndex === -1) {
            return oldData;
        }
        const existingTransaction = updatedTransactions[transactionIndex];
        // Check if we need to recalculate next date
        const recalculateNextDate = existingTransaction.frequency !== request.frequency || existingTransaction.startDate !== request.startDate;
        const nextDate = recalculateNextDate
            ? calculateNextDate(DateTime.fromISO(request.startDate), request.frequency, user?.timeZone || 'UTC')
            : existingTransaction.nextDate;
        updatedTransactions[transactionIndex] = {
            ...existingTransaction,
            ...request,
            nextDate: nextDate || '',
        };
        return updatedTransactions;
    };
    return useQueryMutation(updateRecurringTransactionApi, queryKey, onMutate, options);
};
